<template>
    <div>
        <CreateShelter />
    </div>
</template>

<script>
import CreateShelter from '@/components/shelter/CreateShelter.vue';
export default {
    components: {
        CreateShelter
    },
    name: 'ShelterCreate'
}
</script>